/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementFbInstantOptions, FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementFbInstantOptionsToJSON, } from './FxIdDomainSettingsAdvertisementFbInstantOptions';
export function FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesFromJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementFbInstantOptions(json)) {
        return FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesToJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementFbInstantOptions(value)) {
        return FxIdDomainSettingsAdvertisementFbInstantOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementOptionsFacebookInstantGames.js.map